import { useState } from 'react';
import { Button } from '@mui/material';
import { useNotify, useRecordContext } from 'react-admin';
import constants from '../../constants';

// Super-admin only: download everything the system holds about this member
// (privacy / data-subject-access request) as a JSON file.
const isSuperAdmin = () => localStorage.getItem('role') === 'superadmin';

const MemberFullExportButton = () => {
	const record = useRecordContext();
	const notify = useNotify();
	const [loading, setLoading] = useState(false);

	if (!isSuperAdmin() || !record?.id) return null;

	const handleExport = async () => {
		setLoading(true);
		try {
			const token = localStorage.getItem('token');
			const res = await fetch(
				`${constants.API_URL}member/${record.id}/full-export`,
				{ headers: { Authorization: `Bearer ${token}` } },
			);
			if (!res.ok) throw new Error(`HTTP ${res.status}`);
			const json = await res.json();
			const blob = new Blob([JSON.stringify(json, null, 2)], {
				type: 'application/json',
			});
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = `member-${record.id}-export.json`;
			document.body.appendChild(a);
			a.click();
			a.remove();
			URL.revokeObjectURL(url);
			notify('הייצוא הורד בהצלחה', { type: 'success' });
		} catch (e: any) {
			notify(`ייצוא נכשל: ${e?.message || 'שגיאה'}`, { type: 'error' });
		} finally {
			setLoading(false);
		}
	};

	return (
		<Button
			variant="contained"
			color="secondary"
			onClick={handleExport}
			disabled={loading}
		>
			{loading ? 'מייצא...' : 'ייצוא כל נתוני המשתמש (סופר אדמין)'}
		</Button>
	);
};

export default MemberFullExportButton;
